import Chip from '@mui/material/Chip'
import { useTranslation } from 'react-i18next'

import type { ResourceControlMode } from '@/features/resource/types'

type ControlTypeChipProps = Readonly<{
  controlMode: ResourceControlMode
}>

const BASE_TRANSLATION_KEY = 'component.resource_control_type_chip'

function ControlTypeChip({ controlMode }: ControlTypeChipProps) {
  const { t } = useTranslation()

  const color = controlMode === 'LOCAL' ? 'secondary' : 'primary'
  const label = t(`${BASE_TRANSLATION_KEY}.${controlMode.toLowerCase() as Lowercase<ResourceControlMode>}`)

  return <Chip color={color} label={label} size="small" sx={{ textTransform: 'uppercase' }} variant="outlined" />
}

export default ControlTypeChip
